import { createSelector } from 'reselect'

import { RootState } from '../../reducers'
import { isLockedSelector } from '../app'
import { isAnonymousUserSelector } from '../user/selectors'
import { originalVersionFlowFetchErrorSelector } from '../../features/serverBots/selectors'
import { editingUsersSelector, amIBlockedByExclusiveUiSelector } from '../socketServer/selectors'
import { isOnDisabledDevBotSelector } from '../../features/serverBots/actions/promptForDisabledDevResolution'

const scrollContainerSliceSelector = (s: RootState) => s.scrollContainer

export const scrollContainerTopOffsetSelector = (s: RootState) => {
  return scrollContainerSliceSelector(s).offsetTop
}

export const bannerHeightSelector = createSelector(
  isLockedSelector,
  editingUsersSelector,
  isAnonymousUserSelector,
  isOnDisabledDevBotSelector,
  amIBlockedByExclusiveUiSelector,
  originalVersionFlowFetchErrorSelector,
  (
    isLocked,
    editingUsers,
    isAnonymousUser,
    isOnDisabledDevBot,
    blockedByExclusiveUi,
    originalVersionFetchError
  ) => {
    if (!isLocked) return 0
    if (blockedByExclusiveUi && !originalVersionFetchError) return 56
    if (isOnDisabledDevBot) return 36
    if (isAnonymousUser) return 0
    return !!editingUsers ? 46 : 36
  }
)

export const headerHeightSelector = createSelector(
  scrollContainerTopOffsetSelector,
  bannerHeightSelector,
  (scrollTop, bannerHeight) => {
    const headerHeight = 123 + 58 + bannerHeight
    return headerHeight - Math.min(scrollTop, 66) // No idea what's going on here :(
  }
)

export const isVisibleUpButtonSelector = createSelector(
  scrollContainerTopOffsetSelector,
  scroll => scroll < 25
)

export const isScrollbarVisibleSelector = (s: RootState) => {
  return scrollContainerSliceSelector(s).scrollbarVisible
}
